/*
 * GP instant cart (2026-10-12). Optimistic UI on top of the theme's cart code:
 *  - Add to Cart (PDP button, free-pair "+", recommendation / collection / upsell adds): on the tap itself the drawer opens
 *    with the new line, predicted line prices and totals (from the ladder in #gp-offer-config), the progress bar, the item
 *    count and the add button label; the theme's own /cart/add.js + section re-render then replaces it with the server truth.
 *  - Drawer + / - / remove: applied to the DOM immediately; the network call is debounced (300 ms) and sent once.
 *  - No spinners or overlays (CSS in snippets/gp-cart-instant.liquid). If the server refuses an add, the predicted line is
 *    removed and the button reads "Couldn't add — tap to retry".
 * Reads GPPrice (assets/gp-pricing.js) for the ladder, the prefetched cart and the button labels. Never computes prices itself.
 * ROUND 10 (2026-10-25): the drawer can never STAY wrong. After every cart change settles (add, change, remove; fetch or jQuery),
 * when no other cart request is running, the drawer is re-read from Shopify (newest read wins) and the cart feed is re-read with a
 * read that starts AFTER the change; only then are the predicted changes cleared and count / total / progress repainted from the
 * server. Impossible predictions (negative count, $0 with items) are never painted: the server is re-read instead. Rows that do
 * not add up to the server cart trigger another re-read. A refused add is logged with Shopify's message, the cart is re-read and
 * the add is retried once before "Couldn't add" is shown.
 */
(function () {
  if (window.GPInstant) return;
  // ROUND 10: every cart mutation request is counted (fetch below, jQuery ajax here). When the LAST one settles the drawer is
  // re-read from the server and the predicted changes are cleared; not only when requests overlapped.
  var mutInflight = 0, lastMutationAt = 0, settleTimer = 0, syncSeq = 0, freshPending = 0, verifyTries = 0, settles = 0, staleReadsBlocked = 0;
  var MUT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function mutationStarted() { mutInflight++; lastMutationAt = Date.now(); clearTimeout(settleTimer); }
  function mutationSettled() {
    mutInflight = Math.max(0, mutInflight - 1); lastMutationAt = Date.now();
    if (mutInflight === 0) { clearTimeout(settleTimer); settleTimer = setTimeout(function () { settle('settle'); }, 120); }
  }
  function settle(why) {
    if (mutInflight > 0) return; // a newer request is running: its own settle follows
    settles++; verifyTries = 0;
    rereadDrawer(why); freshRead(why);
  }
  function resync(why) { rereadDrawer(why); freshRead(why); }
  // the drawer section straight from Shopify; the newest read wins and a read overtaken by a new mutation is dropped
  function rereadDrawer(why) {
    var seq = ++syncSeq, sid = sectionId();
    var f = window.__gpNativeFetch || nativeFetch || window.fetch;
    return f(location.pathname + '?section_id=' + encodeURIComponent(sid) + '&_gp=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || seq !== syncSeq || mutInflight > 0) return false;
        if (typeof replaceCartDrawerContentFromSections === 'function') { var s = {}; s[sid] = html; replaceCartDrawerContentFromSections(s); }
        try { document.dispatchEvent(new CustomEvent('gp:resync', { detail: { why: why } })); } catch (e) {}
        return true;
      })
      .catch(function () { return false; });
  }
  // a cart-feed read that STARTS after the last change. GPPrice.refresh() hands back an in-flight read when one is running
  // (it may have started before the change), so a second read is chained behind it; only that one clears the predictions.
  function freshRead(why) {
    var gp = GP(); if (!gp) return Promise.resolve();
    freshPending++;
    var done = function () {
      freshPending = Math.max(0, freshPending - 1);
      if (mutInflight > 0 || hasPendingQty()) return; // a newer change is on its way: its settle clears and repaints
      clearOpt(); repaintFromServer(); verifyAgainstServer(why);
    };
    return Promise.resolve(gp.refresh()).then(function () { return gp.refresh(); }).then(done, done);
  }
  function hasPendingQty() { for (var k in pendingQty) { if (Object.prototype.hasOwnProperty.call(pendingQty, k)) return true; } return false; }
  function clearOpt() { opt = { n: 0, r: 0, nonOffer: 0, baseSum: 0, count: 0 }; }
  // count, total, progress, upsell prices and button labels from the server cart (opt is clear)
  function repaintFromServer() {
    var d = drawer(); if (!d || $('[data-gp-optimistic]', d)) return; // a predicted row still waits for its render: the next settle repaints
    var s = snapshot(); var t = totals(s); if (!t || impossible(s, t)) return;
    try { paintTotalsRaw(s, t); paintProgress(s); paintUpsells(s); paintButtons(s); } catch (e) {}
  }
  // the rows on screen must add up to the server cart; when they do not, the drawer is re-read (up to 3 times, backing off)
  function verifyAgainstServer(why) {
    var gp = GP(); var c = gp && gp.state.cart; if (!c || !c.items) return;
    var server = 0; c.items.forEach(function (it) { server += it.qty; });
    var shown = drawerCount();
    if (shown == null || shown === server) { verifyTries = 0; return; }
    if (verifyTries >= 3) { if (window.console) console.warn('[GPInstant] drawer shows ' + shown + ' pairs, server has ' + server + ' after 3 re-reads'); return; }
    verifyTries++;
    setTimeout(function () {
      if (mutInflight > 0 || hasPendingQty()) return;
      rereadDrawer(why + ':rows ' + shown + '!=' + server).then(function () { freshRead(why + ':verify'); });
    }, 400 * verifyTries);
  }
  // a prediction that cannot be true is never painted; the server is asked instead
  function impossible(s, t) {
    if (!t) return true;
    if (s.count < 0 || s.n < 0 || s.r < 0 || s.nonOffer < 0 || s.baseSum < 0 || t.total < 0) return true;
    if (s.count > 0 && t.total <= 0 && (s.n > 0 || s.r > 0 || s.nonOffer > 0)) return true;
    if (s.count === 0 && (s.n > 0 || s.r > 0)) return true;
    return false;
  }
  function recover(why) {
    if (window.console) console.warn('[GPInstant] impossible prediction, re-reading the cart:', why);
    clearOpt(); repaintFromServer(); resync('impossible');
  }
  // jQuery requests (the mystery-pair add, legacy handlers) count too
  function hookJqMut() {
    if (!window.jQuery || window.__gpInstantJq) return; window.__gpInstantJq = true;
    jQuery(document).ajaxSend(function (e, x, s) { if (s && MUT_RE.test(String(s.url || ''))) mutationStarted(); })
      .ajaxComplete(function (e, x, s) { if (s && MUT_RE.test(String(s.url || ''))) mutationSettled(); });
    // 2026-10-25 v11: a drawer section GET (update_cart_content: gp-cart-fix's 1.2s watchdog, legacy handlers) started while
    // a cart change is still running answers with the cart as it was BEFORE the change. On a slow LTE add the shopper saw
    // "UNLOCKED" -> "ADD 1 MORE PAIR" -> "UNLOCKED" and "MY CART (3)" over 2 rows. Such a read is cancelled here; settle()
    // re-reads the drawer the moment the change has finished, so nothing is lost.
    jQuery.ajaxPrefilter(function (options, original, jqXHR) {
      var u = String(options.url || ''); var m = String(options.type || options.method || 'GET').toUpperCase();
      if (m === 'GET' && /[?&]section_id=/.test(u) && (mutInflight > 0 || hasPendingQty())) { staleReadsBlocked++; jqXHR.abort(); }
    });
  }
  hookJqMut(); document.addEventListener('DOMContentLoaded', hookJqMut);
  var GP = function () { return window.GPPrice && window.GPPrice.ready ? window.GPPrice : null; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { c = Number(c); if (!isFinite(c)) return ''; return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var drawer = function () { return document.getElementById('shopify-section-cart-drawer'); };
  var lastTap = 0;

  // ---------- what the cart will look like after a change (counts per scope, totals) ----------
  var opt = { n: 0, r: 0, nonOffer: 0, baseSum: 0, count: 0 }; // optimistic changes not yet confirmed by a cart read
  document.addEventListener('gp:cart', function (e) {
    if (e.detail && e.detail.optimistic) return;
    if (freshPending > 0) return;                  // a read that started after the last change is on its way: it clears and repaints
    if (mutInflight > 0 || hasPendingQty()) return; // predicted changes still wait for their request: keep them
    clearOpt(); try { paintUpsells(snapshot()); } catch (err) {}
  });
  // ROUND 9: the "+" button is the only control that adds; a click that ends a swipe (> 10 px of movement) is ignored
  var plusDown = null;
  document.addEventListener('pointerdown', function (e) { var b = e.target.closest && e.target.closest('#shopify-section-cart-drawer .cart_drawer_upsell_add'); plusDown = b ? { x: e.clientX, y: e.clientY, moved: false } : null; }, true);
  document.addEventListener('pointermove', function (e) { if (plusDown && (Math.abs(e.clientX - plusDown.x) > 10 || Math.abs(e.clientY - plusDown.y) > 10)) plusDown.moved = true; }, true);
  document.addEventListener('touchmove', function (e) { var t = e.touches && e.touches[0]; if (plusDown && t && (Math.abs(t.clientX - plusDown.x) > 10 || Math.abs(t.clientY - plusDown.y) > 10)) plusDown.moved = true; }, true);
  function plusSwiped() { return !!(plusDown && plusDown.moved); }
  function snapshot() {
    var gp = GP(); var cart = gp && gp.state.cart;
    var s = { n: opt.n, r: opt.r, nonOffer: opt.nonOffer, baseSum: opt.baseSum, count: opt.count };
    if (cart && cart.items) cart.items.forEach(function (it) {
      s.count += it.qty; s.baseSum += (it.base || 0);
      if (it.scope === 'b1g2') s.n += it.qty; else if (it.scope === 'readers3') s.r += it.qty; else s.nonOffer += (it.base || 0);
    });
    return s;
  }
  function totals(s) {
    var gp = GP(); if (!gp) return null;
    var total = gp.expectedTotal('b1g2', s.n) + gp.expectedTotal('readers3', s.r) + s.nonOffer;
    return { total: total, savings: Math.max(0, s.baseSum - total) };
  }
  // price the NEXT unit of a scope pays (Shopify prices pairs in the order they were added)
  function nextUnitPrice(scope, s, base) {
    var gp = GP(); if (!gp) return base;
    if (scope === 'b1g2') return Math.min(base, gp.expectedTotal('b1g2', s.n + 1) - gp.expectedTotal('b1g2', s.n));
    if (scope === 'readers3') return Math.min(base, gp.expectedTotal('readers3', s.r + 1) - gp.expectedTotal('readers3', s.r));
    return base;
  }

  // ---------- DOM painting ----------
  function setMode(count) {
    var h = $('#shopify-section-cart-drawer .section_holder'); if (!h) return;
    h.setAttribute('data-gp3-count', String(count));
    h.setAttribute('data-gp3-mode', count >= 3 ? 'compact' : 'big');
    h.setAttribute('data-gp3-mode-desktop', 'big'); // desktop: big rows at every quantity
  }
  function paintTotals(s) {
    var d = drawer(); var t = totals(s); if (!d) return;
    if (impossible(s, t)) { recover('count ' + s.count + ', n ' + s.n + ', r ' + s.r + ', total ' + (t ? t.total : 'n/a')); return; }
    paintTotalsRaw(s, t);
  }
  function paintTotalsRaw(s, t) {
    var d = drawer(); if (!d || !t) return;
    var count = Math.max(0, s.count), total = Math.max(0, t.total), savings = Math.max(0, t.savings), baseSum = Math.max(0, s.baseSum);
    var rows = $$('.cart_drawer_items_row', d);
    rows.forEach(function (row) {
      var lbl = (row.querySelector('.cart_drawer_items_label') || {}).textContent || '';
      var val = row.querySelector('.cart_drawer_items_count');
      if (!val) return;
      if (/ITEMS/i.test(lbl)) val.textContent = String(count);
      if (/ORIGINAL/i.test(lbl)) val.textContent = money(baseSum);
      if (/SHIPPING/i.test(lbl)) val.textContent = 'FREE';
      if (/SAVINGS/i.test(lbl)) { val.textContent = '−' + money(savings); row.style.display = savings > 0 ? '' : 'none'; }
    });
    var tp = $('.cart_drawer_total_price', d); if (tp) tp.textContent = money(total);
    // V3: header count, YOU SAVE line, row layout (compact from 3 pairs on phones, from 5 on desktop)
    $$('[data-gp3-count-label]', d).forEach(function (el) { el.textContent = '(' + count + ')'; });
    $$('[data-gp3-yousave]', d).forEach(function (el) { el.textContent = 'YOU SAVE ' + money(savings); el.hidden = !(savings > 0); });
    // row layout (big/compact) follows the SERVER render only, so rows never jump under a burst of taps
    $$('[data-bind="itemCount"]').forEach(function (el) { el.textContent = String(count); el.style.display = count > 0 ? '' : 'none'; });
  }
  function paintAll(s) {
    var t = totals(s);
    if (impossible(s, t)) { recover('count ' + s.count + ', n ' + s.n + ', r ' + s.r + ', total ' + (t ? t.total : 'n/a')); return; }
    paintTotalsRaw(s, t); paintProgress(s); paintUpsells(s); paintButtons(s);
  }
  function paintProgress(s) {
    var d = drawer(); var gp = GP(); if (!d || !gp) return;
    var row = $('.gp-offer-row[data-gp-scope="b1g2"]', d); if (!row) return;
    var txt = gp.text && gp.text.step ? gp.text.step[String(Math.min(Math.max(s.n, 0), 4))] : '';
    var sub = $('.gp-offer-sub', row); if (sub && txt) { var parts = txt.split(' · '); sub.innerHTML = '<span class="gp3-progress__main">' + esc(parts[0]) + '</span>' + (parts.length > 1 ? ' <span class="gp3-progress__ship">· ' + esc(parts.slice(1).join(' · ')) + '</span>' : ''); }
    $$('.gp-step', row).forEach(function (el, i) { el.classList.toggle('on', s.n >= i + 1); });
    $$('.gp-bar', row).forEach(function (el, i) { el.classList.toggle('on', s.n >= i + 2); });
    row.classList.toggle('is-done', s.n >= 3);
    var wrap = row.closest('.gp-offer'); if (wrap) wrap.classList.toggle('is-done', s.n >= 3);
    var up = $('.cart_drawer_upsells_heading', d);
    if (up && gp.text && gp.text.upsell) up.textContent = s.n >= 4 ? (gp.text.upsell.at4 || gp.text.upsell.at3) : s.n === 3 ? gp.text.upsell.at3 : gp.text.upsell.under3;
  }
  // upsell cards: the price under each card = what the NEXT pair of that scope costs now (FREE / $15), list price struck
  function paintUpsells(s) {
    var d = drawer(); var gp = GP(); if (!d || !gp) return;
    $$('[data-gp-upsell]', d).forEach(function (card) {
      var scope = card.getAttribute('data-gp-scope') || ''; var base = +card.getAttribute('data-gp-base') || 0; if (!base) return;
      var price = nextUnitPrice(scope, s, base);
      var now = card.querySelector('.gp-upcard__now'), was = card.querySelector('.gp-upcard__was');
      if (now) { var t = price === 0 ? 'FREE' : money(price); if (now.textContent !== t) now.textContent = t; now.classList.toggle('is-free', price === 0); }
      if (was) was.hidden = !(price < base);
    });
  }
  function paintButtons(s) {
    var gp = GP(); if (!gp) return;
    gp.state.n = s.n; gp.state.r = s.r; // other snippets (free-pair picker, bottom bar, product cards) follow the optimistic count
    try { gp.paint(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('gp:cart', { detail: { n: s.n, r: s.r, optimistic: true } })); } catch (e) {}
  }
  // same rule as GPPrice.paintLineBadges: the badge follows the row's own price ($0 -> FREE, extra price -> EXTRA PAIR, paid -> SAVE)
  function lineBadge(scope, price, base, n) {
    var gp = GP(); var b = gp && gp.lineBadgeFor ? gp.lineBadgeFor(scope, base, price, n, 1) : null;
    if (!b) return null;
    return { cls: b.tone === 'green' ? 'gp_free_badge' : (b.msg ? 'gp-msg' : ''), text: b.text };
  }
  function lineHTML(p, n) {
    // V3 row: identical markup to the Liquid row (gp3-line), prices predicted from the ladder until /cart.js confirms
    var badge = lineBadge(p.scope, p.price, p.base, n);
    var kind = !badge ? '' : badge.cls === 'gp_free_badge' ? 'free' : /EXTRA/i.test(badge.text) ? 'extra' : 'save';
    return '<div class="cart_drawer_item gp3-line" data-gp-line data-gp-optimistic data-gp-scope="' + esc(p.scope || '') + '" data-gp-handle="' + esc(p.handle || '') + '" data-gp-base="' + Number(p.base || 0) + '" data-gp-final="' + Number(p.price || 0) + '" data-gp-qty="1" style="order:' + ((p.price === 0 ? 2 : (p.base > 0 && p.price > 0 && p.price < p.base && p.scope === 'b1g2' && n >= 4) ? 3 : 1) * 1000 + 999) + '">' +
      '<div class="cart_item_image_wrapper gp3-line__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" class="cart_item_image" width="256" height="172" draggable="false">' : '') + '</div>' +
      '<div class="cart_drawer_item_details gp3-line__body"><div class="cart_drawer_item_title_row gp3-line__row1"><a class="cart_drawer_item_title gp3-line__name" href="' + esc(p.url || '#') + '">' + esc(p.title) + '</a>' +
      (badge ? '<span class="cart_drawer_item_discount_badge bogo_badge gp3-tag ' + badge.cls + '" data-gp-kind="' + kind + '" data-gp-line-badge-optimistic>' + esc(badge.text) + '</span>' : '') + '</div>' +
      '<div class="gp3-line__row2"><div class="cart_drawer_item_price csapp-price gp3-line__price"><div class="cart-item__discounted-prices"><strong class="bold-price' + (p.price === 0 ? ' is-free' : '') + '">' + (p.price === 0 ? '$0' : money(p.price)) + '</strong>' +
      (p.price < p.base ? '<s class="compare-price price-was">' + money(p.base) + '</s>' : '') + '</div></div>' +
      '<div class="cart_drawer_item_right_col gp3-line__ctl"><div class="cart_drawer_item_qty_selector"><div class="cart_drawer_item_plus_minus"><div class="cart_drawer_item_plus_minus_container gp3-stepper">' +
      '<div class="cart_item_quantity_update gp3-stepper__btn gp-opt-disabled">−</div><div class="cart_drawer_item_quantity gp3-stepper__qty">1</div><div class="cart_item_quantity_update gp3-stepper__btn gp-opt-disabled">+</div></div></div></div>' +
      '<div class="cart_drawer_item_remove gp3-trash gp-opt-disabled" aria-hidden="true"></div></div></div></div></div>';
  }
  function insertLine(p, n) {
    var d = drawer(); if (!d) return false;
    var list = $('.cart_drawer_items_container', d);
    if (!list) {
      // empty cart: swap the empty message for a minimal list + total until the real render arrives
      var main = $('.cart_drawer_main_container', d); if (!main) return false;
      main.classList.remove('cart_drawer_main_container--empty');
      var empty = $('.cd_empty_message', main); if (empty) empty.remove();
      var shellBreakdown = ('<div class="cart_drawer_summary gp3-breakdown gp-opt-shell"><div class="cart_drawer_items_row gp3-breakdown__row"><div class="cart_drawer_items_label">ORIGINAL PRICE</div><div class="cart_drawer_items_count">' + money(p.base) + '</div></div>' +
        '<div class="cart_drawer_items_row free_shipping_bar gp3-breakdown__row"><div class="cart_drawer_items_label">SHIPPING</div><div class="cart_drawer_items_count is-green">FREE</div></div>' +
        '<div class="cart_drawer_items_row gp_savings_row gp3-breakdown__row"><div class="cart_drawer_items_label">SAVINGS</div><div class="cart_drawer_items_count is-green">−' + money(Math.max(0, p.base - p.price)) + '</div></div></div>');
      main.insertAdjacentHTML('afterbegin', '<div class="cart_drawer_items gp3-lines gp-opt-shell"><div class="cart_drawer_items_container"></div></div>' + shellBreakdown);
      var holder = main.parentElement;
      if (holder && !holder.querySelector('.cart_drawer_footer')) holder.insertAdjacentHTML('beforeend', '<div class="cart_drawer_footer gp3-foot gp-opt-shell"><div class="gp3-foot__total"><div class="gp3-foot__left"><div class="cart_drawer_total_text gp3-foot__label">TOTAL</div><div class="gp3-foot__save" data-gp3-yousave>YOU SAVE ' + money(Math.max(0, p.base - p.price)) + '</div></div><div class="cart_drawer_total_price gp3-foot__price">' + money(p.price) + '</div></div>' +
        '<a href="/checkout" class="cart_drawer_checkout_button gp3-checkout"><span>SECURE CHECKOUT</span></a></div>');
      var ov = main.parentElement && main.parentElement.querySelector('.cd_loading_overlay'); if (ov && holder) holder.appendChild(ov);
      $$('[data-gp3-count-label]').forEach(function (el) { el.textContent = '(1)'; });
      list = $('.cart_drawer_items_container', d);
    }
    list.insertAdjacentHTML('afterbegin', lineHTML(p, n));
    return true;
  }

  // ---------- product facts for the tapped button ----------
  function productFor(btn) {
    var p = { variant: btn.getAttribute('data-variant-id'), title: '', image: '', url: '', handle: '', base: 0, scope: null };
    var form = btn.closest('form[action*="/cart/add"]');
    if (!p.variant && form) { var idEl = form.querySelector('[name="id"]'); p.variant = idEl && idEl.value; }
    var ladder;
    if (btn.classList.contains('gp-atc') || (form && btn.type === 'submit')) {
      // product page main button
      var h1 = $('.gp-title'); p.title = h1 ? h1.textContent.trim() : document.title.split('–')[0].trim();
      p.handle = h1 ? h1.getAttribute('data-handle') || '' : ''; p.url = location.pathname;
      // the product's hero image (preloaded by theme.liquid), never the first <img> on the page (that is the POLARIZED badge)
      var pre = $('link[data-gp-hero-preload]'); p.image = pre ? pre.getAttribute('href') : '';
      if (!p.image) { var cand = $$('.gp-gallery img, .gp-pdp img, .product__media img').filter(function (im) { var src = im.currentSrc || im.src || ''; return src && !/polari|badge|icon|logo|xl[-_]/i.test(src) && im.getBoundingClientRect().width > 120; }); p.image = cand[0] ? (cand[0].currentSrc || cand[0].src) : ''; }
      ladder = $('.gp-price [data-gp-ladder]');
    } else {
      var card = btn.closest('.fp__card, .productCard, .new_product_card, .cart_drawer_upsell, .gp-tcard, .gp-cmp__col, [data-gp-ladder-card]') || btn.parentElement;
      var t = card && (card.querySelector('.fp__name, .productCard__title, .product-info-title, .cart_drawer_upsell_title, .gp-tcard__name, .gp-cmp__name') || card.querySelector('img[alt]'));
      p.title = t ? (t.tagName === 'IMG' ? t.alt : t.textContent.trim()) : (btn.getAttribute('aria-label') || '').replace(/^Add\s+/i, '').replace(/\s+to cart.*$/i, '');
      var ci = card && card.querySelector('img'); p.image = ci ? ci.currentSrc || ci.src : '';
      var a = card && card.querySelector('a[href*="/products/"]'); p.url = a ? a.getAttribute('href') : '';
      p.handle = card ? card.getAttribute('data-id') || card.getAttribute('data-handle') || '' : '';
      ladder = card && card.querySelector('[data-gp-ladder]');
      if (!p.handle && p.url) p.handle = p.url.split('/products/')[1] ? p.url.split('/products/')[1].split(/[?#]/)[0] : '';
    }
    if (ladder) { p.scope = ladder.getAttribute('data-gp-scope') || null; p.base = +ladder.getAttribute('data-gp-base') || 0; }
    var upCard = btn.closest('[data-gp-upsell]'); // drawer upsell card: scope + list price on the card itself
    if (upCard) { p.scope = upCard.getAttribute('data-gp-scope') || p.scope; p.base = +upCard.getAttribute('data-gp-base') || p.base; var ut = upCard.querySelector('.gp-upcard__title'); if (ut) p.title = ut.textContent.trim(); }
    if (!p.base) { var gp = GP(); p.base = gp && gp.b1g2 ? gp.b1g2.list : 0; if (!p.scope && btn.hasAttribute('data-fp-add')) p.scope = 'b1g2'; }
    return p;
  }

  // ---------- Add to Cart ----------
  function onAdd(btn) {
    var gp = GP(); if (!gp || !gp.state.known) return; // no ladder knowledge: let the theme do its normal thing
    lastTap = performance.now();
    var s = snapshot(); var p = productFor(btn);
    p.price = nextUnitPrice(p.scope, s, p.base);
    if (p.scope === 'b1g2') { s.n += 1; opt.n += 1; } else if (p.scope === 'readers3') { s.r += 1; opt.r += 1; } else { s.nonOffer += p.base; opt.nonOffer += p.base; }
    s.count += 1; s.baseSum += p.base; opt.count += 1; opt.baseSum += p.base;
    if (typeof window.open_slider_cart === 'function') { try { window.open_slider_cart(); } catch (e) {} }
    insertLine(p, s.n); paintAll(s);
    // button feedback: ADDED ✓ for a second, then the next label
    var main = $('button.gp-atc'); var target = btn.classList.contains('gp-atc') ? btn : null;
    if (target) { var next = gp.buttonLabel(s.n) || target.textContent; target.textContent = 'ADDED ✓'; target.setAttribute('data-gp-added', '1'); setTimeout(function () { if (target.getAttribute('data-gp-added')) { target.removeAttribute('data-gp-added'); target.textContent = next; } }, 1000); }
    else if (main && p.scope === 'b1g2') { main.textContent = gp.buttonLabel(s.n) || main.textContent; }
    window.GPInstant.lastOptimisticAt = performance.now();
    document.dispatchEvent(new CustomEvent('gp:optimistic', { detail: { type: 'add', ms: window.GPInstant.lastOptimisticAt - lastTap } }));
  }
  // ---------- drawer upsell "+": ONE handler (2026-10-12). The theme's addUpsellProduct no longer runs for these buttons. ----------
  // optimistic row at once -> one /cart/add.js (plain variant, no line properties, so the same variant merges into one line) ->
  // drawer re-render from the response. Busy until that render; a refusal shows a message on the button and restores it.
  function sectionId() { try { return typeof getCartDrawerSectionId === 'function' ? getCartDrawerSectionId() : 'cart-drawer'; } catch (e) { return 'cart-drawer'; } }
  function upsellAdd(btn) {
    var card = btn.closest('.cart_drawer_upsell');
    var sel = card && card.querySelector('.cart_drawer_upsell_variants');
    var vid = (sel && sel.value) || btn.getAttribute('data-variant-id');
    if (!vid) { fail('No variant'); return; }
    var sid = sectionId();
    btn.setAttribute('data-gp-busy', '1'); btn.setAttribute('aria-disabled', 'true');
    var label = btn.querySelector('.gp-upcard__added') ? null : btn; // text buttons get ADDED, icon buttons keep their icon
    var prevHTML = btn.innerHTML; if (label && !btn.querySelector('svg')) btn.textContent = 'ADDED';
    try { onAdd(btn); } catch (err) { if (window.console) console.warn('[GPInstant] optimistic add failed', err); }
    function fail(why) {
      $$('[data-gp-optimistic]').forEach(function (n) { n.remove(); });
      btn.removeAttribute('data-gp-busy'); btn.removeAttribute('aria-disabled');
      if (!btn.querySelector('svg')) btn.textContent = "Couldn't add · tap again"; else btn.innerHTML = prevHTML;
      btn.setAttribute('title', why || "Couldn't add"); btn.classList.add('gp-add-failed');
      if (card) { var m = card.querySelector('.gp-add-error'); if (!m) { m = document.createElement('div'); m.className = 'gp-add-error'; card.appendChild(m); } m.textContent = "Couldn't add — tap + again"; }
      if (window.console) console.error('[GPInstant] upsell add failed after a retry:', why);
      resync('add-failed');
    }
    // ROUND 10: a refused add is logged with Shopify's message, the cart is re-read, and the add is sent once more
    function send(attempt) {
      mutationStarted();
      return (window.__gpNativeFetch || window.fetch)('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: [sid], sections_url: location.pathname }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { mutationSettled(); return { ok: r.ok, status: r.status, json: j }; }); }, function (e) { mutationSettled(); throw e; })
        .then(function (res) {
          if (!res.ok) {
            var why = (res.json && (res.json.description || res.json.message)) || ('HTTP ' + res.status);
            if (window.console) console.error('[GPInstant] Shopify refused /cart/add.js (variant ' + vid + ', try ' + (attempt + 1) + '):', why, res.json);
            if (attempt === 0) return rereadDrawer('add-refused').then(function () { return freshRead('add-refused'); }).then(function () { return send(1); });
            fail(why); return;
          }
          if (res.json && res.json.sections && typeof replaceCartDrawerContentFromSections === 'function') replaceCartDrawerContentFromSections(res.json.sections);
          else rereadDrawer('add-no-sections');
          if (typeof update_header_icon === 'function') update_header_icon();
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        })
        .catch(function (err) {
          if (window.console) console.error('[GPInstant] /cart/add.js request failed (try ' + (attempt + 1) + '):', err);
          if (attempt === 0) return rereadDrawer('add-error').then(function () { return send(1); });
          fail(err && err.message);
        });
    }
    send(0);
  }
  document.addEventListener('click', function (e) {
    // ROUND 9: image and text of an upsell card never add (swiping the carousel used to add pairs)
    var up = e.target.closest && e.target.closest('#shopify-section-cart-drawer .cart_drawer_upsell_add');
    if (up) {
      e.preventDefault(); e.stopImmediatePropagation(); // the inline onclick (theme addUpsellProduct) must not run: one request per tap
      if (plusSwiped()) { plusDown = null; return; } // the finger moved: a swipe, not a tap
      if (up.hasAttribute('data-gp-busy')) return;
      var gp0 = GP(); if (!gp0 || !gp0.state.known) { try { addUpsellProduct(up); } catch (err) {} return; } // no ladder knowledge: theme path
      upsellAdd(up); return;
    }
    var btn = e.target.closest && e.target.closest('button.gp-atc, [data-fp-add], .rec-add, .productCard__button-atc[button-type="atc"], .collection-add-to-cart, [button-type="atc"]');
    if (!btn || btn.disabled || btn.classList.contains('is-disabled')) return;
    if (btn.closest('#shopify-section-cart-drawer')) return;
    try { onAdd(btn); } catch (err) { if (window.console) console.warn('[GPInstant] optimistic add failed', err); }
  }, true);

  // ---------- drawer + / - / remove: paint now, send once ----------
  var pendingQty = {};
  function lineOf(el) { return el.closest('.cart_drawer_item'); }
  // every line of the row's variant -> quantity 0 (grouped rows can hold several line keys)
  function removeKeys(keys) {
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    var sid = sectionId();
    mutationStarted();
    return (window.__gpNativeFetch || window.fetch)('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [sid], sections_url: location.pathname }) })
      .then(function (r) { mutationSettled(); return r.json(); }, function (e) { mutationSettled(); throw e; })
      .then(function (j) { if (j && j.sections && typeof replaceCartDrawerContentFromSections === 'function') replaceCartDrawerContentFromSections(j.sections); else if (typeof update_cart_content === 'function') update_cart_content(); if (typeof update_header_icon === 'function') update_header_icon(); })
      .catch(function () { if (typeof update_cart_content === 'function') update_cart_content(); });
  }
  function onQty(el, delta, remove) {
    var line = lineOf(el); if (!line || line.hasAttribute('data-gp-optimistic')) return false;
    var key = el.getAttribute('data-id'); if (!key) return false;
    var qEl = line.querySelector('.cart_drawer_item_quantity');
    var p = pendingQty[key];
    // the row shows every line of this variant (data-gp-qty); the network call changes the FIRST line (data-quantity) by its key
    var lineQty = p ? p.lineQty : (+el.getAttribute('data-quantity') || 1);
    var shown = p ? p.shown : (+line.getAttribute('data-gp-qty') || +(qEl && qEl.textContent) || lineQty);
    // sub-rows (one per price tier of the same style): "-" lowers the Shopify line by one; the whole line goes only when the
    // group (every row of this variant) reaches 0, or on trash
    var groupQty = 0; $$('[data-gp-line][data-gp-variant="' + (line.getAttribute('data-gp-variant') || '') + '"]', drawer()).forEach(function (r) { if (r.style.display !== 'none') groupQty += (+r.getAttribute('data-gp-qty') || 0); });
    if (!groupQty) groupQty = shown;
    var all = remove || (groupQty + delta <= 0);
    var nextLine = all ? 0 : Math.max(0, lineQty + delta), nextShown = all ? 0 : Math.max(0, shown + delta);
    if (!all && delta < 0 && lineQty === 0) return false; // the first line is already gone: let the render catch up
    var scope = line.getAttribute('data-gp-scope') || '';
    var s = snapshot(); var d = nextShown - shown;
    var unitBase = Math.round((+line.getAttribute('data-gp-base') || 0) / Math.max(1, shown));
    if (scope === 'b1g2') { s.n += d; opt.n += d; } else if (scope === 'readers3') { s.r += d; opt.r += d; } else { s.nonOffer += d * unitBase; opt.nonOffer += d * unitBase; }
    s.count += d; s.baseSum += d * unitBase; opt.count += d; opt.baseSum += d * unitBase;
    if (nextShown === 0) line.style.display = 'none'; else if (qEl) qEl.textContent = String(nextShown);
    paintAll(s);
    if (p) clearTimeout(p.timer);
    pendingQty[key] = { lineQty: nextLine, shown: nextShown, all: all, timer: setTimeout(function () {
      var st = pendingQty[key]; delete pendingQty[key];
      var keys = (line.getAttribute('data-gp-keys') || key).split(',').filter(Boolean); if (!keys.length) keys = [key];
      try {
        if (st.all) removeKeys(keys);
        else if (st.lineQty === 0) removeKeys([key]);
        else { el.setAttribute('data-quantity', String(st.lineQty - 1)); increaseCartItem(el); } // the theme reads data-quantity + 1 and sends one update
      } catch (err) { if (typeof update_cart_content === 'function') update_cart_content(); }
    }, 300) };
    return true;
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('#shopify-section-cart-drawer .cart_item_quantity_update, #shopify-section-cart-drawer .cart_drawer_item_remove');
    if (!el || el.classList.contains('gp-opt-disabled')) return;
    var gp = GP(); if (!gp || !gp.state.known) return;
    var isRemove = el.classList.contains('cart_drawer_item_remove');
    var delta = isRemove ? 0 : (/decrease/i.test(el.getAttribute('onclick') || '') || el === lineOf(el).querySelector('.cart_item_quantity_update') ? -1 : 1);
    if (onQty(el, delta, isRemove)) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  // ---------- rollback when the server refuses ----------
  var nativeFetch = window.fetch;
  function rollbackAdd(why) {
    $$('[data-gp-optimistic]').forEach(function (n) { n.remove(); });
    $$('.gp-opt-shell').forEach(function (n) { n.remove(); });
    $$('.cart_drawer_upsell_add[data-gp-busy]').forEach(function (b) { b.removeAttribute('data-gp-busy'); b.removeAttribute('aria-disabled'); });
    var b = $('button.gp-atc[data-gp-added], button.gp-atc'); if (b) { b.removeAttribute('data-gp-added'); b.textContent = "Couldn't add — tap to retry"; }
    if (window.console) console.error('[GPInstant] add failed after a retry:', why);
    resync('add-rollback');
  }
  function readJson(res) { try { return res.clone().json().catch(function () { return {}; }); } catch (e) { return Promise.resolve({}); } }
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (MUT_RE.test(url)) { mutationStarted(); p.then(mutationSettled, mutationSettled); }
      // ROUND 10: a refused add (theme button, free-pair picker, collection card) is logged with Shopify's message, the cart is
      // re-read and the same request is sent once more before the predicted row is rolled back
      if (/\/cart\/add(\.js)?/.test(url)) p.then(function (res) {
        if (!res || res.ok) return;
        var status = res.status;
        readJson(res).then(function (j) {
          var why = (j && (j.description || j.message)) || ('HTTP ' + status);
          if (window.console) console.error('[GPInstant] Shopify refused /cart/add.js:', why, j);
          var body = init && init.body;
          rereadDrawer('add-refused').then(function () { return freshRead('add-refused'); }).then(function () {
            if (!body) { rollbackAdd(why); return; }
            mutationStarted();
            return nativeFetch(url, init).then(function (r2) {
              mutationSettled();
              if (r2.ok) {
                return readJson(r2).then(function (j2) {
                  if (j2 && j2.sections && typeof replaceCartDrawerContentFromSections === 'function') replaceCartDrawerContentFromSections(j2.sections); else rereadDrawer('add-retry-ok');
                  if (typeof update_header_icon === 'function') update_header_icon();
                  var b = $('button.gp-atc[data-gp-added]'); if (b) { b.removeAttribute('data-gp-added'); var gp = GP(); if (gp) b.textContent = gp.buttonLabel(gp.state.n) || b.textContent; }
                });
              }
              return readJson(r2).then(function (j2) { rollbackAdd((j2 && (j2.description || j2.message)) || ('HTTP ' + r2.status)); });
            }, function (e) { mutationSettled(); rollbackAdd(e && e.message); });
          });
        });
      }, function () {});
    } catch (e) {}
    return p;
  };

  // after the real render lands, note the reconciliation time for the audit
  // the upsell carousel always starts at its first card after a render (the theme's swiper keeps an old offset otherwise)
  function resetCarousel() {
    var d = drawer(); if (!d) return;
    $$('.cart_drawer_upsells_swiper', d).forEach(function (el) {
      try { if (el.swiper && !el.swiper.destroyed) el.swiper.slideTo(0, 0); } catch (e) {}
      el.scrollLeft = 0; var w = el.querySelector('.swiper-wrapper'); if (w) { w.scrollLeft = 0; if (!el.swiper) w.style.transform = ''; }
    });
  }
  // V3 (phones): while the drawer is open it sits in the page flow and the DOCUMENT scrolls (the Facebook / Instagram in-app
  // top bar collapses only on page scroll); header and footer are sticky (CSS in gp-cart-skin-v3). The page's scroll position
  // is saved on open and restored on close. Desktop keeps the fixed 420px panel.
  var docTimer = 0, savedScrollY = 0;
  function enterDocScroll(d) {
    if (window.innerWidth >= 750 || document.body.classList.contains('gp3-docscroll')) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    var n = d.parentElement; while (n && n !== document.body) { n.classList.add('gp3-keep'); n = n.parentElement; }
    document.documentElement.classList.add('gp3-docscroll'); document.body.classList.add('gp3-docscroll');
    window.scrollTo(0, 0); fbPad();
    try { document.dispatchEvent(new CustomEvent('gp3:docscroll', { detail: { on: true } })); } catch (e) {}
  }
  // Facebook / Instagram in-app browser only: the cart document is at least 110% of the window height, so a scroll gesture
  // always exists (that is what collapses the in-app top bar). A trailing spacer sits under the sticky footer, never between
  // the content and the footer.
  var IN_APP = /FBAN|FBAV|FB_IAB|Instagram/i.test(navigator.userAgent);
  function fbPad() {
    var d = drawer(); var holder = d && d.querySelector('.section_holder'); if (!holder) return;
    var pad = holder.querySelector('.gp3-fbpad'); if (!IN_APP || !document.body.classList.contains('gp3-docscroll')) { if (pad) pad.remove(); return; }
    if (!pad) { pad = document.createElement('div'); pad.className = 'gp3-fbpad'; holder.appendChild(pad); }
    pad.style.height = '0px';
    var natural = holder.getBoundingClientRect().height; var need = Math.ceil(window.innerHeight * 1.1) - natural;
    pad.style.height = (need > 0 ? need : 0) + 'px';
  }
  function exitDocScroll() {
    if (!document.body.classList.contains('gp3-docscroll')) return;
    document.documentElement.classList.remove('gp3-docscroll'); document.body.classList.remove('gp3-docscroll');
    Array.prototype.forEach.call(document.querySelectorAll('.gp3-keep'), function (n) { n.classList.remove('gp3-keep'); });
    void document.body.offsetHeight; // reflow: the page content is back in flow before the scroll position is restored
    var y = savedScrollY; window.scrollTo(0, y); requestAnimationFrame(function () { window.scrollTo(0, y); });
    try { document.dispatchEvent(new CustomEvent('gp3:docscroll', { detail: { on: false } })); } catch (e) {}
  }
  window.addEventListener('resize', function () { var d = drawer(); if (!d) return; if (window.innerWidth >= 750) exitDocScroll(); else if (d.classList.contains('slided')) enterDocScroll(d); });
  (function watchOpen() {
    var d = drawer(); if (!d) { document.addEventListener('DOMContentLoaded', watchOpen); return; }
    var was = d.classList.contains('slided');
    new MutationObserver(function () {
      var on = d.classList.contains('slided');
      if (on && !was) { var b = d.querySelector('.cart_drawer_main_container'); if (b) b.scrollTop = 0; resetCarousel(); clearTimeout(docTimer); docTimer = setTimeout(function () { if (d.classList.contains('slided')) enterDocScroll(d); }, 260); }
      if (!on && was) { clearTimeout(docTimer); exitDocScroll(); }
      was = on;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  })();
  var carouselTimer = 0;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var a = muts[i].addedNodes; for (var j = 0; j < a.length; j++) { var nd = a[j]; if (nd.nodeType === 1 && (nd.matches && (nd.matches('.cart_drawer_upsells, .cart_drawer_upsells_swiper, [data-gp-upsell]') || nd.querySelector('.cart_drawer_upsells_swiper')))) { clearTimeout(carouselTimer); carouselTimer = setTimeout(resetCarousel, 60); setTimeout(resetCarousel, 400); return; } } }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart-drawer:open', function () { setTimeout(resetCarousel, 50); });
  new MutationObserver(function () {
    if (!window.GPInstant.lastOptimisticAt) return;
    var d = drawer(); if (!d) return;
    if ($('[data-gp-line]:not([data-gp-optimistic])', d) && !$('[data-gp-optimistic]', d)) {
      window.GPInstant.lastReconciledMs = performance.now() - lastTap; window.GPInstant.lastOptimisticAt = 0;
      document.dispatchEvent(new CustomEvent('gp:reconciled', { detail: { ms: window.GPInstant.lastReconciledMs } }));
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ROUND 8: the drawer must match the server cart after a reload mid-request or a change in another tab.
  function drawerCount() {
    var d = drawer(); if (!d) return null;
    if ($('[data-gp-optimistic]', d)) return null; // a predicted row is pending: not comparable
    var rows = $$('[data-gp-line]:not([data-gp-optimistic])', d).filter(function (r) { return r.style.display !== 'none'; });
    if (!rows.length) return $('.cd_empty_message', d) || $('.cart_drawer_main_container--empty', d) ? 0 : null;
    var n = 0; rows.forEach(function (r) { n += +r.getAttribute('data-gp-qty') || +((r.querySelector('.cart_drawer_item_quantity') || {}).textContent) || 0; });
    return n;
  }
  var lastSyncCheck = 0;
  function checkSync(why, knownCount) {
    if (mutInflight > 0 || Date.now() - lastMutationAt < 1500 || Date.now() - lastSyncCheck < 1500) return;
    var shown = drawerCount(); if (shown == null) return;
    lastSyncCheck = Date.now();
    var compare = function (serverCount) { if (serverCount != null && serverCount !== shown) resync(why + ':' + shown + '->' + serverCount); };
    if (typeof knownCount === 'number') { compare(knownCount); return; }
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c && mutInflight === 0 && drawerCount() === shown) compare(c.item_count); }).catch(function () {});
  }
  document.addEventListener('gp:cart', function (e) { if (e.detail && e.detail.optimistic) return; var c0 = GP() && GP().state.cart; if (c0 && c0.items) { var k = 0; c0.items.forEach(function (it) { k += it.qty; }); setMode(k); } });
  document.addEventListener('gp:cart', function (e) { // server read by gp-pricing (page load, reload): compare without another request
    if (e.detail && e.detail.optimistic) return;
    var gp = GP(); var c = gp && gp.state.cart; if (!c || !c.items) return;
    var n = 0; c.items.forEach(function (it) { n += it.qty; }); checkSync('load', n);
  });
  window.addEventListener('pageshow', function () { setTimeout(function () { checkSync('pageshow'); }, 300); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') checkSync('visible'); });
  (function watchOpenSync() {
    var d = drawer(); if (!d) { document.addEventListener('DOMContentLoaded', watchOpenSync); return; }
    var was = d.classList.contains('slided');
    new MutationObserver(function () { var on = d.classList.contains('slided'); if (on && !was) checkSync('open'); was = on; }).observe(d, { attributes: true, attributeFilter: ['class'] });
  })();

  // V3: carousel arrows (desktop, shown on hover): one card per click
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#shopify-section-cart-drawer [data-gp3-arrow]'); if (!a) return;
    e.preventDefault(); e.stopPropagation();
    var sw = a.parentElement.querySelector('.cart_drawer_upsells_swiper'); if (!sw) return;
    var dir = a.getAttribute('data-gp3-arrow') === 'prev' ? -1 : 1;
    if (sw.swiper && !sw.swiper.destroyed) { if (dir < 0) sw.swiper.slidePrev(); else sw.swiper.slideNext(); return; }
    var w = sw.querySelector('.swiper-wrapper') || sw; w.scrollBy({ left: dir * 150, behavior: 'smooth' });
  }, true);

  document.addEventListener('gp:cart', function () { setTimeout(fbPad, 50); });
  new MutationObserver(function () { if (document.body.classList.contains('gp3-docscroll')) { clearTimeout(fbPadTimer); fbPadTimer = setTimeout(fbPad, 80); } }).observe(document.documentElement, { childList: true, subtree: true });
  var fbPadTimer = 0;
  window.GPInstant = { version: 11, resync: resync, staleReadsBlocked: function () { return staleReadsBlocked; }, rereadDrawer: rereadDrawer, freshRead: freshRead, inflight: function () { return mutInflight; }, pending: hasPendingQty, settled: function () { return settles; }, fbPad: fbPad, enterDocScroll: enterDocScroll, exitDocScroll: exitDocScroll, checkSync: checkSync, drawerCount: drawerCount, resetCarousel: resetCarousel, snapshot: snapshot, totals: totals, upsellAdd: upsellAdd, removeKeys: removeKeys, paintUpsells: paintUpsells, lastOptimisticAt: 0, lastReconciledMs: null };
})();
